/*
  PeekWild inline header search: search buttons open a bar that replaces the header row, with
  predictive suggestions below it. Esc, the close button or a click outside closes it.
*/
(() => {
  const panel = document.querySelector('[data-pw-search]');
  if (!panel) return;
  const header = panel.closest('header-component') || document.querySelector('header-component');
  const input = panel.querySelector('[data-pw-search-input]');
  const results = panel.querySelector('[data-pw-search-results]');
  const toggles = () => document.querySelectorAll('[data-pw-search-toggle]');
  let lastTrigger = null;
  let timer = null;
  let controller = null;

  const setExpanded = (value) => toggles().forEach((b) => b.setAttribute('aria-expanded', String(value)));

  const open = (trigger) => {
    lastTrigger = trigger || null;
    panel.hidden = false;
    header?.setAttribute('data-pw-search-open', '');
    setExpanded(true);
    requestAnimationFrame(() => input.focus());
  };

  const close = ({ restoreFocus = true } = {}) => {
    if (panel.hidden) return;
    panel.hidden = true;
    header?.removeAttribute('data-pw-search-open');
    results.innerHTML = '';
    setExpanded(false);
    controller?.abort();
    if (restoreFocus && lastTrigger && lastTrigger.offsetParent !== null) lastTrigger.focus();
  };

  const suggest = (term) => {
    controller?.abort();
    if (term.length < 2) { results.innerHTML = ''; return; }
    controller = new AbortController();
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const url = `${root}search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,article,page&resources[limit]=4&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=pw-predictive-search`;
    fetch(url, { signal: controller.signal })
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        if (panel.hidden || input.value.trim() !== term) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const block = doc.querySelector('[data-pw-suggest]');
        results.innerHTML = block ? block.outerHTML : '';
      })
      .catch(() => {});
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-pw-search-toggle]');
    if (toggle) {
      event.preventDefault();
      panel.hidden ? open(toggle) : close();
      return;
    }
    if (event.target.closest('[data-pw-search-close]')) { close(); return; }
    if (!panel.hidden && !panel.contains(event.target)) close({ restoreFocus: false });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); close(); }
  });

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const term = input.value.trim();
    timer = setTimeout(() => suggest(term), 200);
  });
})();
